import { EngagementTheme } from "../enums/EngagementTheme";
import { EngagementType } from "../models/stewardshipModels";

export const THEME_TO_META_THEME: Record<EngagementTheme, EngagementType> = {
  [EngagementTheme.CIRCULAR_ECONOMY_AND_ZERO_POLLUTION]:
    EngagementType.Environmental,
  [EngagementTheme.CLIMATE_CHANGE]: EngagementType.Environmental,
  [EngagementTheme.NATURAL_RESOURCE_STEWARDSHIP]: EngagementType.Environmental,
  [EngagementTheme.HUMAN_CAPITAL]: EngagementType.Social,
  [EngagementTheme.HUMAN_AND_LABOUR_RIGHTS]: EngagementType.Social,
  [EngagementTheme.WIDER_SOCIETAL_IMPACTS]: EngagementType.Social,
  [EngagementTheme.PURPOSE_STRATEGY_AND_POLICIES]:
    EngagementType.StrategyRiskCommunication,
  [EngagementTheme.RISK_MANAGEMENT]: EngagementType.StrategyRiskCommunication,
  [EngagementTheme.BOARD_EFFECTIVENESS]: EngagementType.Governance,
  [EngagementTheme.EXECUTIVE_REMUNERATION]: EngagementType.Governance,
  [EngagementTheme.INVESTOR_PROTECTION_AND_RIGHTS]: EngagementType.Governance,
};

const ENGAGEMENT_THEMES: string[] = Object.values(EngagementTheme);

export const isEngagementTheme = (value: string): value is EngagementTheme =>
  ENGAGEMENT_THEMES.includes(value);

export const toMetaTheme = (theme: string): EngagementType =>
  isEngagementTheme(theme)
    ? THEME_TO_META_THEME[theme]
    : EngagementType.StrategyRiskCommunication;
